import { Link } from 'react-router-dom';
import { blogArticles } from '@/mocks/blog';

export default function BlogSection() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-6 md:px-10">
        <div className="text-center mb-12">
          <p className="text-xs font-label tracking-widest uppercase text-accent-600 mb-3">
            Latest Articles
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
            Mulebuy Spreadsheet Guides &amp; Resources
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            In-depth articles, tutorials, and comparisons to help you master your <strong>mulebuy spreadsheet</strong> workflow
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {blogArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/blog/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-300 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="w-full aspect-[16/10] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-label">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2 mt-4 pt-3 border-t border-background-100">
                  <span className="text-xs text-foreground-400">{article.date}</span>
                  <span className="text-primary-600 text-xs font-medium flex items-center gap-1 ml-auto">
                    Read more
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/shopping-guide"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-full border-2 border-primary-300 text-primary-700 text-sm font-semibold hover:bg-primary-50 hover:border-primary-500 transition-colors whitespace-nowrap cursor-pointer"
          >
            View Shopping Guide
            <i className="ri-guide-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}